import {useState, useEffect} from 'react';
import {withTransition} from "./animation";
import {client} from './contentful';

const useContentful = () => {
    const [data, setData] = useState(null);

    useEffect(() => {
        if (data === null) {
            client.getEntries({content_type: `multipleChoiceQuestion`})
                .then(entries => {
                    setData(entries.items);
                })
                .catch(console.error);
        }
    });

    return data;
};

const useAnime = props =>
    useEffect(() => withTransition(props));

export {useContentful, useAnime};
